<h2 mat-dialog-title>{{ title }}</h2>
<mat-dialog-content>
  <mat-stepper linear #stepper>
    <form [formGroup]="importEpuForm">
      <mat-step [stepControl]="file"
                [label]="stepLabel">
        <ng-template matStepContent>
          <mat-card class="width-100 mat-elevation-z0">
            <mat-card-content>
              Format pliku:
              <p>{{ formatDescription }}</p>
              <app-import-payments-select-file formControlName="file"
                                               class="width-100">
              </app-import-payments-select-file>
            </mat-card-content>
            <mat-card-actions>
              <button mat-raised-button
                      action-button
                      color="primary"
                      matStepperNext
                      [disabled]="importEpuForm.invalid"
                      [action]="importEpu.bind(this)">
                {{ actionLabel }}
              </button>
            </mat-card-actions>
          </mat-card>
        </ng-template>
      </mat-step>
    </form>
  </mat-stepper>
</mat-dialog-content>
